import { makeStyles, shorthands } from '@fluentui/react-components';
import backgroundImg from '../../media/updateBg.png';

export const useStyles = makeStyles({
  container: {
    maxWidth: '500px',

    '& .dialog-body': {
      ...shorthands.overflow('hidden'),
    },

    '& .update-image': {
      width: '324px',
      height: '189px',
      backgroundSize: '100% 100%',
      backgroundImage: `url("${backgroundImg}")`,
      ...shorthands.margin('4px', 'auto', '16px', 'auto'),
    },

    '& .tip-title': {
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '16px',
      lineHeight: '20px',
    },

    '& .tip-info': {
      ...shorthands.margin('12px', '0', '16px', '0'),
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#605E5C',
      ...shorthands.overflow('hidden'),
    },

    '& .error-tip': {
      marginBottom: '16px',

      '& .alert.alert-danger': {
        ...shorthands.padding('8px'),
      },

      '& .alert__icon': {
        color: '#A80000',
        width: '16px',
        height: '16px',
        fontSize: '16px',
        lineHeight: '16px',
        marginRight: '8px',
      },
    },
  },
});
